import React, { useState, useEffect } from 'react';
import { processError } from '../../services/ServiceUtils';
import { getAllStrategies, getStrategy } from '../../services/StrategiesService';
import { getEventObject } from '../../utils/EventUtils';

/**
 * props:
 * - symbol
 * - strategyId
 * - onlyActives
 * - showLabel
 * - onChange
 */
function SelectStrategy(props) {

    const [strategies, setStrategies] = useState([]);
    const [strategyId, setStrategyId] = useState('');

    useEffect(() => {
        if (!props.strategyId) return setStrategyId('');

        setStrategyId(props.strategyId);
    }, [props.strategyId]);

    useEffect(() => {
        getAllStrategies(props.symbol, props.onlyActives)
            .then(result => setStrategies(result))
            .catch(err => setStrategies([processError(err)]));
    }, [props.symbol, props.onlyActives]);

    async function onStrategyChange(event) {
        if (!event.target.value) {
            // selecionou opcao nenhum
            props.onChange(getEventObject('strategyId', null));
            props.onChange(getEventObject('automationIds', []));
            props.onChange(getEventObject('concreteSymbol', null));
            return;
        }

        const id = parseInt(event.target.value);
        const listStrategy = strategies.find(s => s.id === id);
        setStrategyId(id);

        // Estratégias AI Full / multi-automação têm buy/sellAutomationId NULOS e linkam tudo por strategyId
        // (supportingAutomations). Buscar a estratégia COMPLETA e montar automationIds de buy+sell+suporte
        // (dedupe, sem nulos) — senão o backtest ia com [null] e a AI Full não rodava (paridade com pallas).
        let automationIds;
        try {
            const full = await getStrategy(id);
            automationIds = [...new Set([
                full.buyAutomationId,
                full.sellAutomationId,
                ...((full.supportingAutomations || []).map(a => a.id)),
            ].filter(Boolean))];
        } catch (err) {
            // Fallback ao comportamento legado (buy/sell) se a busca falhar.
            automationIds = listStrategy.sellAutomationId !== listStrategy.buyAutomationId
                ? [listStrategy.sellAutomationId, listStrategy.buyAutomationId].filter(Boolean)
                : [listStrategy.sellAutomationId].filter(Boolean);
        }

        // Coringa (*USDT): concretiza pro símbolo selecionado, que o cobre (ex.: BTCUSDT). O backend usa
        // concreteSymbol pra trocar o token *QUOTE nas conditions/indexes/OT e ter candles/MEMORY reais.
        const isWildcard = !!(listStrategy.symbol && listStrategy.symbol.startsWith('*'));
        const concreteSymbol = isWildcard ? props.symbol : null;

        if (props.onChange) {
            props.onChange(getEventObject('strategyId', id));
            props.onChange(getEventObject('automationIds', automationIds));
            props.onChange(getEventObject('concreteSymbol', concreteSymbol));
        }
    }

    return (
        <select className='form-select' id='strategy' value={strategyId || ''} onChange={onStrategyChange}>
            <option value=''>{props.allLabel || 'Selecionar estratégia...'}</option>
            {
                strategies && strategies.length
                    ? strategies.map(s => (<option key={s.id} value={s.id}>{s.name}</option>))
                    : <React.Fragment></React.Fragment>
            }
        </select>
    )
}

export default SelectStrategy;